import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["text", "status"]

  async copy() {
    let copied = false
    try {
      await navigator.clipboard.writeText(this.textTarget.value)
      copied = true
    } catch {
      this.textTarget.focus()
      this.textTarget.select()
      this.textTarget.setSelectionRange(0, this.textTarget.value.length)
      try {
        copied = document.execCommand("copy")
      } catch {
        copied = false
      }
    }
    this.statusTarget.textContent = copied ? this.statusTarget.dataset.success : this.statusTarget.dataset.error
  }
}
